export default __webpack_public_path__ + "static/media/MetafightGetStarted-min.f9a5c2ea.png";